// src/pages/Vision/Vision.js
import './Vision.scss'
import { useRefs } from '../../context/RefContext'
import Aos from 'aos';
import 'aos/dist/aos.css'; // Corrected AOS CSS import
import { useEffect } from 'react';
import { Trans} from "@lingui/react/macro"

const Vision = () =>
{
    useEffect(() =>
    {
        Aos.init({ duration: 1000, once: true, easing: 'ease-in-out' });
    }, []); // Empty dependency array means this runs once on mount

    const { visionRef } = useRefs();


    return (
        <div ref={visionRef} className='vision-section'>
            <div className='vision-container'>

                {/* Block 1: Left Justified */}
                <div className='vision-content-block' data-aos="fade-right">
                    <div className='vision-title-column'>
                    <div className='block'><Trans>UN FUTURO</Trans></div>
                    <div className='block outline'><Trans>EN EXPLORACIÓN</Trans></div>
                    </div>
                    <div className='vision-paragraph-column'>
                    <p><Trans><strong>Visualizamos</strong> una red interconectada de <strong>puertos espaciales distribuidos por todo el planeta</strong>, con infraestructura y asistencia para operar desde vuelos experimentales, suborbitales, orbitales, hasta reentradas y viajes planetarios complejos, tripulados y no tripulados. Esta visión se completa con naves espaciales, y comprende <strong>lanzamientos frecuentes para exploración, turismo espacial, colonización planetaria, minería y reabastecimiento de estaciones.</strong> Así concebimos el futuro: accesible, estandarizado y operativamente eficiente.</Trans></p>
                    </div>
                </div>

                {/* Block 2: Right Justified */}
                <div className='vision-content-block swapped' data-aos="fade-left">
                    <div className='vision-title-column'>
                    <div className='block'><Trans>EL MOMENTO</Trans></div>
                    <div className='block outline'><Trans>ES AHORA</Trans></div>
                    </div>
                    <div className='vision-paragraph-column'>
                    <p><Trans>Creemos que el camino para dar este salto hacia el espacio y las estrellas está comenzando, y la iniciativa de <strong>The Cosmic Shores</strong> acelerará el paso. Nuestro compromiso es allanar el terreno para que las naves del futuro puedan acceder al espacio de manera eficiente y segura.<strong> Nos enfocamos en el desarrollo de la infraestructura necesaria y los servicios de asistencia especializados para asegurar operaciones frecuentes y exitosas.</strong> Somos conscientes y realistas en el arte de adaptar responsablemente la Tierra al crecimiento exponencial del sector espacial en las próximas décadas. Nos propusimos ser <strong>artífices de la hazaña</strong> de promover realmente que la especie humana dé este paso tan esperado por milenios.
</Trans></p>
                    </div>
                </div>

    {/* Block 3: Left Justified */}
                
            <div className='vision-content-block' data-aos="fade-right">
                    <div className='vision-title-column'>
                    <div className='block'><Trans>ESTÁNDARES <br/> GLOBALES</Trans></div>
                    <div className='block outline'><Trans>Y EXPANSIÓN</Trans></div>
                    </div>
                    <div className='vision-paragraph-column'>
                    <p><Trans>La red de puertos espaciales se adherirá a <strong>estándares globales para la infraestructura de lanzamiento, retorno y aterrizaje</strong>, así como para la <strong>integración de cargas útiles, pruebas de vehículos experimentales y entrenamiento de astronautas.</strong> The Cosmic Shores busca activamente alianzas estratégicas para contribuir a la <strong>estandarización global de los espaciopuertos y los sistemas de tierra.</strong> Mediante un crecimiento planificado y estandarizado, no sólo se reducirán costos y complejidades, sino que se evitarán incompatibilidades y se reutilizarán recursos y tecnologías.<br/>En la etapa presente, <strong>“Cosmic”</strong> se enfrenta a barreras para superar los desafíos regionales, evaluando el potencial geográfico de cada ubicación y las inversiones requeridas.</Trans></p>
                    </div>
                </div>
            
            </div>
        </div>
    );
};

export default Vision;
